import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IPolicyResponse } from '@interfaces/policy-response.interface';
import { DataService } from 'src/app/core/services/data.service';
import { InsuranceService } from 'src/app/core/services/insurance.service';
import { BreadcrumbComponent } from 'src/app/shared/components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'aig-history-policy',
  imports: [CommonModule, BreadcrumbComponent],
  templateUrl: './history-policy.component.html',
  styleUrl: './history-policy.component.scss',
})
export class HistoryPolicyComponent {
  //#region Variables
  idPoliza!: number;
  numDocumento!: string;

  public policiesDto: IPolicyResponse[] = [];

  get isPolicyActive(): boolean {
    return this.policiesDto.some((p) => p.idEstado === 1);
  }

  get activePolicies(): IPolicyResponse[] {
    return this.policiesDto.filter((p) => p.idEstado === 1);
  }

  get expiredPolicies(): IPolicyResponse[] {
    return this.policiesDto.filter((p) => p.idEstado !== 1);
  }

  get hasExpiredPolicies(): boolean {
    return this.expiredPolicies.length > 0;
  }

  //#endregion

  //#region Constructor & life-cycle hooks
  constructor(
    private router: Router,
    private dataService: DataService,
    private insuranceService: InsuranceService
  ) {}

  ngOnInit(): void {
    this.idPoliza = this.dataService.getPoliza();
    this.numDocumento = this.dataService.getNumDocumento();

    if (this.numDocumento) {
      this.loadPolicies(this.numDocumento);
    } else {
      console.error('Número de documento no disponible');
    }
  }
  //#endregion

  //#region Methods

  private loadPolicies(numDocumento: string): void {
    this.insuranceService.obtenerPolizas(numDocumento).subscribe({
      next: (data) => {
        this.policiesDto = data;
      },
      error: (err) => {
        console.error('Error al obtener las pólizas', err);
      },
    });
  }

  policyState(arg: number | undefined): string {
    switch (arg) {
      case 1:
        return '';
      case 2:
        return 'cancel';
      case 3:
        return 'inactive';
      case 5:
        return 'inactive';
      case 6:
        return 'inactive';
      default:
        return '';
    }
  }

  public goToPolicyDetail(policy: IPolicyResponse): void {
    this.router.navigate(['/area-cliente/historial-polizas/detalles'], {
      state: { policy },
    });
  }

  //#endregion

  cargarPolizas(numDocumento: string) {
    console.log('cargar polizas: ', numDocumento);
    this.insuranceService.obtenerPolizas(numDocumento).subscribe({
      next: (data) => {
        this.policiesDto = data;
      },
      error: (err) => {
        console.error('Error al obtener las pólizas', err);
      },
    });
  }
}
